import { Component, OnInit } from '@angular/core';
import { CrossoverService } from 'src/app/services/crossover.service';
import * as Highcharts from 'highcharts';
import { TradingSystemSummary } from 'src/app/models/trading-system-summary';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TradingSystemSummaryComponent } from '../../shared/trading-system-summary/trading-system-summary.component';
import { HighchartsChartModule } from 'highcharts-angular';
import { MdbSelectModule } from 'mdb-angular-ui-kit/select';
import { ListaPulsantiMercatiComponent } from '../../shared/lista-pulsanti-mercati/lista-pulsanti-mercati.component';

@Component({
  selector: 'app-analisi-m45',
  standalone: true,
  templateUrl: './analisi-m45.component.html',
  styleUrls: ['./analisi-m45.component.scss'],
  imports: [HighchartsChartModule, TradingSystemSummaryComponent,
    CommonModule, ReactiveFormsModule, MdbSelectModule,
    ListaPulsantiMercatiComponent
  ]
})
export class AnalisiM45Component implements OnInit {

  ts!: TradingSystemSummary

  tableData: any = []
  headers = ['market', 'punti', 'profit euro', 'operazioni', 'punti op', 'perc pos', 'media pos', 'media neg', 'rawal', 'max DD']

  Highcharts: typeof Highcharts = Highcharts;
  chartConstructor: string = 'chart';
  chartOptions: Highcharts.Options = {}

  updateFlag: boolean = false; // optional boolean
  oneToOneFlag: boolean = true; // optional boolean, defaults to false
  runOutsideAngular: boolean = false; // optional boolean, defaults to false
  runOutsideAngularFlag = false; // optional boolean, defaults to false

  formTrading: FormGroup = new FormGroup({
    stopLoss: new FormControl(0),
    takeProfit: new FormControl(0),
  })
  listaTrades: any[] = []
  mercatoSel: any
  idAttuale: number = 0
  datiTotali: number = 0
  puntiTot: number = 0
  percpos: number = 0
  positive: number = 0

  constructor(private service: CrossoverService) { }

  ngOnInit(): void {
  }

  selectMarket(market: any) {
    this.mercatoSel = market
    this.service.lista_m15(market.market).subscribe((data: any) => {
      console.log(data)
      this.tableData = data.dati
      if (data.res == 'ok') {
        this.datiTotali = data.dati.length
        data.dati.map((el: any) => {
          el.punti = el.verso == 'buy' ? el.prezzoclose - el.prezzoopen : el.prezzoopen - el.prezzoclose
        })
        this.ts = new TradingSystemSummary().popolaDati(market.market, market.pip, data.dati)
        this.ts.spread = market.spread
        this.aggiornaGrafico(market, data.dati)
      }
    })
  }

  tradingSystem() {
    let sl = this.formTrading.get('stopLoss')?.value
    let tp = this.formTrading.get('takeProfit')?.value
    let arr = this.tableData.map((el: any) => {
      el.stoploss = sl
      el.takeprofit = tp
      return el
    })
    this.listaTrades = []
    this.puntiTot = 0
    this.percpos = 0
    this.positive = 0
    this.trades(arr, 0)
  }

  trades(arr: any[], idx: number) {
    this.idAttuale = idx
    if (idx == arr.length) {
      console.log(this.listaTrades)
      let dati = this.listaTrades
      dati.map((el: any) => {
        el.punti = el.verso == 'buy' ? el.prezzoclose - el.prezzoopen : el.prezzoopen - el.prezzoclose
      })
      this.ts = new TradingSystemSummary().popolaDati(this.mercatoSel.market, this.mercatoSel.pip, dati)
      this.ts.spread = this.mercatoSel.spread
      this.aggiornaGrafico(this.mercatoSel.market, dati)
      return
    }
    let op = arr[idx]
    this.service.trade(op).subscribe((data: any) => {
      if (data.res == 'ok') {
        if (data.dati.verso) {
          this.listaTrades.push(data.dati)
          this.puntiTot += data.dati.profit
          this.positive += data.dati.profit > 0 ? 1 : 0
          this.percpos = 100 * this.positive / this.listaTrades.length
        }
        this.trades(arr, idx + 1)
      }
    })
  }

  aggiornaGrafico(mkt: any, dati: any[]) {
    let p = 0;
    let progr = dati.map((a: any) => {
      p += +a.profit
      return p
    })
    let pm = 0
    let pMax = 0
    progr.map((a: any) => {
      pm = a > pm ? a : pm
      pMax = (pm - a) > pMax ? (pm - a) : pMax
    })
    let mk = this.tableData.find((el: any) => el.market == mkt.market)
    mk.maxdd = pMax
    //let p2 = progr.map((a: any) => a/2)
    this.chartOptions = {
      title: {
        text: mkt.market
      },
      series: [{
        data: progr,
        type: 'line',
        name: 'Equity line'
      }
      ]
    }
  }

}
